import DocumentService from '@/services/DocumentService.js';

const documents = {
  namespaced: true,

  state: {
    // estado con el documento actual
    currentDocument: null,
    // etado que indica si el documento se ha cargado
    documentLoaded: false,
    // estado con los tipos de dominios
    documentTypes: [],
    // estado para alamcenar los documentos
    documents: [],
    // estado que indica carga vista documentos
    loadingDocuments: false,
    // numero de paginas de documentos
    totalPages: 0,
  },

  mutations: {
  },

  actions: {
    /**
     * Acciones para el modulo de gestión de productos
     * 1- getDocumentDomains: acion para obetenr los dominios de documentos
     * 2- getDocuments: accion para obtener los desarrollos paginados
     * 3- saveDocument: accion para guardar un documento
     * 4- downloadDevelopmentsReport: Accion para descargar reporte word
     */
    async getDocumentDomains({ commit, state }) {
      /**
       * Accion para obtener los dominios catastrales
       *
       * @param {Object} context datos del modulo
       * @example
       * $store.dispatch('cadastral/getDocumentDomains')
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      const token = localStorage.getItem('token');
      try {
        const response = await DocumentService.getDocumentDomains(token);
        if (response.data) {
          state.documentTypes = response.data.document_types;
          return { obtained: true };
        }
        return null;
      } catch (error) {
        commit('ui/SHOW_ALERT',{
          alertMessage: `Ocurrio un error al obtener los dominios del documento
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
        return { obtained: false };
      }
    },
    async getDocuments({ commit, state }, { pageSize, page, searchQuery }) {
      /**
       * Accion para obtener el listado paginado de los documentos
       *
       * @param {Object} context datos del modulo
       * @param {Object} payload datos de la paginacion
       * @example
       * $store.dispatch('documents/getDocuments', {
       *  pageSize: 10,
       *  page: 1,
       *  searchQuery: 'mi_busqueda',
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      const token = localStorage.getItem('token');
      state.loadingDocuments = true;
      try {
          const response = await DocumentService.getDocuments(token, pageSize, page, searchQuery);
          if (response) {
            state.documents = response.data.documents;
            state.totalPages = response.data.total_pages;
          }
      } catch (error) {
        commit('ui/SHOW_ALERT',{
          alertMessage: `Ocurrio un error al cargar los folios
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
      }
      state.loadingDocuments = false;
    },
    async saveDocument({ state, commit, rootState }, documentData) {
      /**
       * Accion para obtener los dominios catastrales
       *
       * @param {Object} context datos del modulo
       * @param {Object} documentData datos del documento
       * @example
       * $store.dispatch('documents/saveDocument', {
       *  name: 'ESCRITURA 3980',
       *  number: '3980',
       *  date: '2025-08-24',
       *  entity: 'NOTARIA 63 DE BOGOTA D.C.',
       *  selectedCity: '15001',
       *  selectedType: '<type_id>',
       *  file: File(),
       *  annotation: <id>,
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      try {
        state.documentLoaded = false;
        const token = localStorage.getItem('token');
        const response = await DocumentService.saveDocument(documentData, token);
        if (response) {
          commit('ui/SHOW_ALERT',{
            alertMessage: 'Se cargó el documento correctamente en el sistema',
            alertType: 'success'
          }, {root: true});
          if (documentData.annotation !== '') {
            const documentRes = response.data.document;
            const annotationId = response.data.annotation_id;
            // actualizar los datos del documento en el store
            rootState.folios.currentFolio.anotaciones = rootState.folios.currentFolio.anotaciones.map((x) => {
              if (x.id === annotationId) {
                return { ...x, archivo: documentRes };
              }
              return x;
            });
            rootState.annotations.currentAnnotations = rootState.annotations.currentAnnotations.map((x) => {
              if (x.id === annotationId) {
                return { ...x, archivo: documentRes };
              }
              return x;
            });
          } else {
            // indicar que el documento se ha ccargado
            state.documentLoaded = true;
          }
          
        }
      } catch (error) {
          commit('ui/SHOW_ALERT',{
            alertMessage: `Ocurrio un error almacenar el documento en el sistema
              (${error.response.status} - ${error.response.data.detail})`,
            alertType: 'error'
          }, {root: true});
      }
    },
    async updateDocument({ state, commit }, documentData) {
      try {
        state.documentLoaded = false;
        const token = localStorage.getItem('token');
        const response = await DocumentService.updateDocument(documentData, token);
        if (response) {
          commit('ui/SHOW_ALERT', {
            alertMessage: 'Se actualizó el documento correctamente en el sistema',
            alertType: 'success'
          }, {root: true});
          state.documentLoaded = true;
          return { updated: true };
        }
      } catch (error) {
        commit('ui/SHOW_ALERT', {
          alertMessage: `Ocurrio un error al actualizar el documento en el sistema
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
      }
      return { updated: false };
    },
    async getDocumentDetail({ commit, state }, documentId) {
      const token = localStorage.getItem('token');
      state.loadingDocument = true;
      try {
          const response = await DocumentService.getDocumentDetail(documentId, token);
          if (response) {
            state.currentDocument = response.data;
          }
          state.loadingDocument = false;
      } catch (error) {
        state.loadingDocument = false;
        commit('ui/SHOW_ALERT',{
          alertMessage: `Ocurrio un error al cargar la informacion del documento
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
      }
    },
    async deleteDocument({ commit }, documentId) {
      /**
       * Accion para eliminar un documneto
       *
       * @param {Object} context datos del modulo
       * @param {Object} documentId ID del documento
       * @example
       * $store.dispatch('documents/deleteDocument', '<document_uuid>')
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      try {
        const token = localStorage.getItem('token');
        const response = await DocumentService.deleteDocument(token, documentId);
        if (response) {
          commit('ui/SHOW_ALERT',{
            alertMessage: 'Se eliminó el documento correctamente del sistema',
            alertType: 'success'
          }, {root: true});
          return { deleted: true };
        }
      } catch (error) {
        commit('ui/SHOW_ALERT',{
          alertMessage: `Ocurrio un error eliminar el documento en el sistema
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
        return { deleted: false };
      }
    },
  },
};

export default documents;
